import { connect } from 'react-redux';
import { compose, hoistStatics, withState, withHandlers, lifecycle } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Login from './Login';
import fh from '../../helpers/form.helper';
import AuthService from '../../services/auth.service';
import { userActions } from '../../reducers/user';
import { authActions } from '../../reducers/auth';
import { settingsActions } from '../../reducers/settings';
import { permissionsActions } from '../../reducers/permissions';
import { moduleActions } from '../../reducers/modules';
import ModuleService from '../../services/module.service';
import * as wsOperations from '../../reducers/websockets/operations';
import WithLoading from '../../components/WithLoading';

const defaultFormData = {
  username: '',
  password: '',
};

const auth = async (props, token, user, permissions) => {
  const {
    setUser,
    setPermissions,
    setModules,
    setToken,
    connectSocketToServer,
    subscribeToChannel,
  } = props;
  await AuthService.setToken(token);
  await setUser({ user });
  await setPermissions(permissions);
  const { data } = await ModuleService.getData({ installed: true });
  await setModules(data);
  await setToken({ token });
  connectSocketToServer();
  subscribeToChannel('common');
};

const onSubmit = props => async (e) => {
  e.preventDefault();
  const {
    formData:
      {
        username,
        password,
        social,
      },
    setWasValidated,
    setFormData,
    setValid,
    updateSettings,
    setIsBanned,
    history,
    t,
    ...rest
  } = props;
  const { token, user, permissions, banned, enable2faEmail, enable2faSms }
  = await AuthService.login(username, password, social);

  setWasValidated(true);

  if (enable2faEmail) {
    setValid(true);
    setIsBanned(false);
    setFormData(defaultFormData);
    await updateSettings({ show2faPages: true });
    return history.push('/check-email');
  }
  if (enable2faSms) {
    await updateSettings({ show2faPages: true });
    return history.push(`/phone-code/${enable2faSms.id}`);
  }
  if ((token && user)) {
    setValid(true);
    setIsBanned(false);

    if (!(token && user)) {
      toast.success(t('Check your e-mail inbox'));
    } else {
      await auth(rest, token, user, permissions);
    }
  } else {
    setValid(false);
    setIsBanned(banned);
  }
};

const findGetParameter = (parameterName) => {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

const check2FaEmailCode = async (props) => {
  const id = findGetParameter('id');
  const code = findGetParameter('code');
  if (id && code) {
    const { token, user, permissions } = await AuthService.checkAuthCode(id, code);
    if (token && user) {
      await auth(props, token, user, permissions);
    }
  }
};

const mapStateToProps = state => ({
  loginColor: state.settings.subscriber.login_color,
  loginLayout: state.settings.subscriber.login_layout || 1,
  socialLoginLayout: state.settings.subscriber ? state.settings.subscriber.login_modules_theme : 1,
  slogan: state.settings.subscriber.slogan,
  canRegister: !!state.settings.subscriber.can_register,
});

const mapDispatchToProps = {
  setUser: userActions.setUser,
  setToken: authActions.setToken,
  setModules: moduleActions.setModules,
  setPermissions: permissionsActions.setPermissions,
  updateSettings: settingsActions.updateSettings,
  connectSocketToServer: wsOperations.connectSocketToServer,
  subscribeToChannel: wsOperations.subscribeToChannel,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('code', 'setCode', ''),
  withState('valid', 'setValid', false),
  withState('isBanned', 'setIsBanned', false),
  withState('wasValidated', 'setWasValidated', false),
  withState('isLoading', 'setIsLoading', true),
  withState('socialModules', 'setSocialModules', []),
  withState('formData', 'setFormData', defaultFormData),
  lifecycle({
    async componentDidMount() {
      await check2FaEmailCode(this.props);
      const { formData, setFormData, t, setIsLoading } = this.props;
      setIsLoading(false);
      const email = window.localStorage.getItem('userEmail');
      const social = window.localStorage.getItem('social');

      if (email) {
        toast.success(t('Some user has such email, please log in to connect your social account'));

        setFormData({
          ...formData,
          username: email,
          social,
        });
      }

      window.localStorage.removeItem('userEmail');
      window.localStorage.removeItem('social');
    },
  }),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Login)));



// WEBPACK FOOTER //
// ./src/views/login/index.js